<template>
  <div>
    <ion-header translucent>
      <ion-toolbar>
        <ion-title> <b> Finalizar solicitud: </b></ion-title>
        <ion-buttons slot="end">
          <!-- <ion-button class="close-modal" @click="dismissModal(stringId)"> <ion-icon name="close-circle-outline"></ion-icon></ion-button> -->
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <section>
        <h6> Resumen de la solicitud</h6>
          <simple-card-finalizado 
            v-for="solicitud in [cardInfo]" 
            v-bind:key="solicitud.id" 
            v-bind:cardInfo="solicitud"
            v-bind:itFinish=itFinish />
      </section>
      <smile-rating :id="'ID-'+StrID"  :str-id="StrID" :allInfo="cardInfo" />
    </ion-content>
  </div>
</template>

<script>
import axios from 'axios';
import firebase from '../config'
import SimpleCardFinalizado from '../components/SimpleCardFinalizado.vue'
import {func} from '../func.js'
// import VueSignature from "vue-signature-pad";
// import vueSignarture from "vue-signature"
import SmileRating from "./SmileRating"
const { db } = firebase;
let dt = require('dateformat');
export default {
  name: 'Modal',
  components:{SmileRating,SimpleCardFinalizado },
  props: {

  },
  firestore: {
    // solicitudesDisponibles: db.collection('todos'),
  },
  data() {
    return {
      itFinish:false,
      isSaved:0,
      content: 'Content',
      datos:{},
      usrGenerico:"Caleb Martinez",
      
      lineWidth: 6,
      lineColor: '#000000',
      bgColor: '',
      resultImg: '',
      isCrop: false,

      solicitudesDisponibles:[],
      stringId:"",
      unidades:[],
      operadores:[],
      
    }
  },
  methods: {
    returnNumberID(_string){
      return func.returnID(_string);
    },
    dismissModal() {
      // this.modifyAlterSet();
      // if( this.isSaved ){ window.location.href = "/solicitudes" ; return; }
      document.querySelector("ion-modal").dismiss();
    },
		// addWaterMark(){
		// 	var _this = this;
		// 	_this.$refs.signature.addWaterMark({
		// 		text:"mark text",          // watermark text, > default ''
		// 		font:"20px Arial",         // mark font, > default '20px sans-serif'
		// 		style:'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill		
		// 		fillStyle:"red",           // fillcolor, > default '#333' 
		// 		strokeStyle:"blue",	   // strokecolor, > default '#333'	
		// 		x:100,                     // fill positionX, > default 20
		// 		y:200,                     // fill positionY, > default 20				
		// 		sx:100,                    // stroke positionX, > default 40
		// 		sy:200                     // stroke positionY, > default 40
		// 	});
		// },
		// fromDataURL(url){
		// 	var _this = this;
		// 	_this.$refs.signature.fromDataURL("data:image/png;base64,iVBORw0K...");
		// },
		// handleDisabled(){
		// 	var _this = this;
		// 	_this.disabled  = !_this.disabled
		// }
  },
  mounted(){
    
    // this.lResponsable = this.getResponsable() 
  },
  created(){
    // let _self = this;
    // let _info = _self.$storage.get("user-info");
    // _self.usrGenerico = _info.name;
    // _self.getUnidades();
    // _self.getOpAndAyudamtes();
  }
}
</script>
<style lang="scss" scoped>
  .close-modal{font-size:20px;}
  .center{text-align: center;}
  .m5{
    margin-top:5px; 
    margin-bottom:5px; 
  }
  p{
    &.w100{
      width: 100%;
    }
  }
  span{
    &.right-text{
      float:right;
      
    }
  }
  .action-sheet-selected.sc-ion-action-sheet-md {
      font-weight: 900;
      color: #630b0b;
  }
  div.action-sheet-group.action-sheet-group-cancel.sc-ion-action-sheet-md > button > span{
    font-size: 1.4em !important;
    font-weight: 700 !important;
  }
  div.action-sheet-group.action-sheet-group-cancel.sc-ion-action-sheet-md > button{background: #ecb4b4 !important;}
  .action-sheet-cancel{
    /* right: 0px; */
    background: #ecb4b4 !important;
  }
  button.action-sheet-group action-sheet-group-cancel sc-ion-action-sheet-md{
    background: #ecb4b4 !important;
  }
</style>